import React, { Component } from "react"
import "./BuyButton.scss"
import { push } from "../../Services/Analytics"
class BuyButton extends Component {
    constructor(props) {
        super();
        this.doClick = this.doClick.bind(this);
        this.state = {}
    }
    doClick() {
        push("Order Button", this.props.sectionName);
        window.fbq('track', 'MondialContentOrderbtn');

        var google_conversion_id = 854687585;
        window.google_conversion_label = "vX8XCOrwjIQBEOH-xZcD";
        var google_custom_params = window.google_tag_params;
        var google_remarketing_only = true;
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://www.googleadservices.com/pagead/conversion.js?t=' + Math.random();
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', `conv-${Math.random()}`));
        var _image = new Image();
        _image.src = "//googleads.g.doubleclick.net/pagead/viewthroughconversion/854687585/?label=G2cLCLeOhoQBEOH-xZcD&guid=ON&script=0";

        window.setTimeout(this.props.onClick, 100);
    }
    render() {
        return (
            <div className="purchase" onClick={this.props.onClick ? this.doClick : null}>
                <div className="text">{this.props.buttonText}</div>
                <div className="add">
                    <div className="plus"></div>
                </div>
            </div>
        )
    }
}

export default BuyButton;


// WEBPACK FOOTER //
// ./src/Components/Helpers/Buttons/BuyButton.jsx